import StatisticsOverviewView from "@/statistics/views/StatisticsOverviewView.vue";
import StatisticsClientsView from "@/statistics/views/StatisticsClientsView.vue";
import StatisticsQuotesView from "@/statistics/views/StatisticsQuotesView.vue";
import StatisticsInvoicesView from "@/statistics/views/StatisticsInvoicesView.vue";
import StatisticsCollectionsView from "@/statistics/views/StatisticsCollectionsView.vue";

// meta.usesMetric : le sous-onglet propose le choix Facturé / Encaissé
export const statisticsRoutes = [
  {
    path: "/statistics",
    name: "StatisticsOverview",
    component: StatisticsOverviewView,
    meta: {usesMetric: true},
  },
  {
    path: "/statistics/clients",
    name: "StatisticsClients",
    component: StatisticsClientsView,
    meta: {usesMetric: true},
  },
  {
    path: "/statistics/quotes",
    name: "StatisticsQuotes",
    component: StatisticsQuotesView,
  },
  {
    path: "/statistics/invoices",
    name: "StatisticsInvoices",
    component: StatisticsInvoicesView,
    meta: {usesMetric: true},
  },
  {
    path: "/statistics/collections",
    name: "StatisticsCollections",
    component: StatisticsCollectionsView,
  },
];
